import { ComponentProps, PropsWithChildren } from "react";

import { Label } from "@design-system/Label/Label";
import { Text } from "@design-system/Text/Text";

import classes from "./FieldGroup.module.css";

type Props = PropsWithChildren<{
  label: ComponentProps<typeof Label>["label"];
  error?: string;
  required?: boolean;
  placement?: ComponentProps<typeof Label>["placement"];
}>;

export const FieldGroup = ({
  children,
  label,
  error,
  required,
  placement,
}: Props) => {
  return (
    <div className={classes.fieldGroup}>
      <Label label={`${label}${required ? "*" : ""}`} placement={placement}>
        {children}
      </Label>
      {error && (
        <Text size={12} color="danger">
          {error}
        </Text>
      )}
    </div>
  );
};
